import {CALL_API} from '../../middleware/api';

export const GET_CONTRACT_TYPES_REQUEST = 'GET_CONTRACT_TYPES_REQUEST';
export const GET_CONTRACT_TYPES_SUCCESS = 'GET_CONTRACT_TYPES_SUCCESS';
export const GET_CONTRACT_TYPES_FAILURE = 'GET_CONTRACT_TYPES_FAILURE';

export function getContractTypes() {
	return {
		[CALL_API]: {
			types: [GET_CONTRACT_TYPES_REQUEST, GET_CONTRACT_TYPES_SUCCESS, GET_CONTRACT_TYPES_FAILURE],
			endpoint: 'contract/contract/get-contract-types',
		}
	};
}



// WEBPACK FOOTER //
// ./src/action/process/contractStartForm.js